export default {
    indexUserSettings:      { method: 'get',    url: 'user_settings' },
    createUserSetting:      { method: 'post',   url: 'user_settings'},
    destroyUserSetting:     { method: 'delete', url: 'user_settings/{id}'},
    updateUserSetting:      { method: 'put',    url: 'user_settings/{id}'},
    
}